export const dedicationOptions = [
  { key: 'dedicated', label: 'Dedicado', isChecked: false },
  { key: 'shared', label: 'Compartilhado', isChecked: false },
];
